module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-2021-8.9ea0f8f2.jpg";